import { render, staticRenderFns } from "./order-detail-success.vue?vue&type=template&id=06e647b2&scoped=true&"
import script from "./order-detail-success.vue?vue&type=script&lang=js&"
export * from "./order-detail-success.vue?vue&type=script&lang=js&"
import style0 from "./order-detail-success.vue?vue&type=style&index=0&id=06e647b2&lang=scss&scoped=scoped&"
import style1 from "./order-detail-success.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e647b2",
  null
  
)

export default component.exports